module.exports = __webpack_public_path__ + "static/media/import_productos.80e53c54.xlsx";